import type {CustomDealStockStatus} from '../../../types';

import {cn} from '@ds/helpers';

type StockBadgeProps = {
  stock?: number;
  status?: CustomDealStockStatus;
};

const STOCK_STYLES: Record<Exclude<CustomDealStockStatus, 'UNSPECIFIED'>, string> = {
  STOCK_OUT: 'bg-destructive-surface text-destructive-heavy',
  STOCK_LOW: 'bg-yellow-soft text-yellow-dark-03',
  STOCK_IN: 'bg-success-surface text-success-heavy'
};

const StockBadge: React.FC<StockBadgeProps> = ({stock = 0, status = 'UNSPECIFIED'}) => {
  if (status === 'UNSPECIFIED') {
    return null;
  }

  return (
    <span className={cn('whitespace-nowrap rounded px-1.5 py-px text-body-xs', STOCK_STYLES[status])}>
      موجود ({stock})
    </span>
  );
};

export default StockBadge;
